// extracted by mini-css-extract-plugin
export var blue = "_13-g";
export var brand = "_13-c";
export var darkGrey = "_13-f";
export var disabled = "_13-6";
export var disabledSubtle = "_13-7";
export var error = "_13-8";
export var green = "_13-h";
export var grey = "_13-e";
export var icon = "_13-0";
export var inherit = "_13-b";
export var lightGrey = "_13-d";
export var orange = "_13-j";
export var pink = "_13-l";
export var primary = "_13-1";
export var purple = "_13-m";
export var quaternary = "_13-4";
export var quinary = "_13-5";
export var red = "_13-k";
export var secondary = "_13-2";
export var success = "_13-a";
export var tertiary = "_13-3";
export var warning = "_13-9";
export var white = "_13-n";
export var yellow = "_13-i";